import jsDataMonitorRoute from './dataMonitor';
import singleEndLogRoute from './singleEndMonitor';
import doubleEndLogRoute from './doubleEndMonitor';
import jsDataReport from './dataReport';
import JSDataMonitorRoot from '@/views/dataReport/jsDataMonitor';
import {JS_DATA_MONITOR_ROOT} from '@/enmus/PageNames';
export default {
    path: 'jsDataMonitor',
    name: JS_DATA_MONITOR_ROOT,
    component: JSDataMonitorRoot,
    redirect: jsDataMonitorRoute.path,
    meta: {
        name: JS_DATA_MONITOR_ROOT,
        title: 'JS数据监控'
    },
    children: [
        jsDataMonitorRoute,
        doubleEndLogRoute,
        singleEndLogRoute,
        jsDataReport
    ]
};